<script setup lang="ts">
  const props = defineProps({
    modelValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    tooltipText: { type: String, default: 'Select Color for the GI Data Collection' }
  })

  const emit = defineEmits(['update:modelValue'])

  const colorSwatches = [
    ['#FF0000', '#AA0000', '#550000'],
    ['#FFFF00', '#AAAA00', '#555500'],
    ['#00FF00', '#00AA00', '#005500'],
    ['#00FFFF', '#00AAAA', '#005555'],
    ['#0000FF', '#0000AA', '#000055']
  ]
</script>

<template>
  <div class="d-flex ga-4">
    <v-tooltip :text="props.tooltipText">
      <template v-slot:activator="{ props }">
        <v-icon v-bind="props" class="text-grey-darken-1">mdi-palette</v-icon>
      </template>
    </v-tooltip>
    <v-color-picker
      :disabled="props.disabled"
      elevation="0"
      class="border-grey"
      :modelValue="props.modelValue"
      @update:modelValue="emit('update:modelValue', $event)"
      :modes="['hex']"
      :swatches="colorSwatches"
      :show-swatches="true"
      swatches-max-height="100px"
      :hide-sliders="true"
      rounded="false"
    />
  </div>
</template>

<style scoped>
  :deep(.v-color-picker__controls) {
    padding: 4px 0;
  }

  .border-grey {
    border: 1px solid #e0e0e0;
  }
</style>
